import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export function PortalShell({ eyebrow, title, subtitle, children, authOverride, brand, homePath = "/", roleLabel, headerTagline }) {
  const aliwerAuth = useAuth();
  const auth = authOverride || aliwerAuth;
  const { user, logout } = auth;
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate(homePath);
  };

  return (
    <div className="min-h-screen bg-black grain" data-testid="portal-shell">
      <header className="sticky top-0 z-40 bg-black/60 backdrop-blur-2xl border-b border-white/10">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to={homePath}>
            {brand || <Logo />}
          </Link>
          <div className="flex items-center gap-4">
            <Link
              to="/"
              data-testid="portal-back-to-site"
              className="hidden sm:inline-flex items-center gap-1.5 text-sm text-fog hover:text-paper transition-colors"
            >
              <ArrowLeft size={14} /> Back to site
            </Link>
            {headerTagline && (
              <span className="hidden lg:block font-display text-sm tracking-tight text-fog mr-2" data-testid="header-tagline">
                {headerTagline}
              </span>
            )}
            <span className="hidden sm:inline text-sm text-fog" data-testid="portal-user">
              {user?.name} · <span className="uppercase text-xs tracking-widest">{roleLabel || user?.role}</span>
            </span>
            <button
              onClick={doLogout}
              data-testid="portal-logout"
              className="rounded-full bg-paper text-black text-sm font-medium px-5 py-2 hover:bg-white transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-[1200px] mx-auto px-6 lg:px-10 py-14 lg:py-20">
        <p className="text-xs uppercase tracking-[0.3em] text-fog mb-4">{eyebrow}</p>
        <h1 className="font-display text-4xl sm:text-5xl tracking-tighter text-paper">{title}</h1>
        {subtitle && <p className="mt-4 text-sm text-fog max-w-xl leading-relaxed">{subtitle}</p>}
        <div className="mt-12">{children}</div>
      </main>
    </div>
  );
}
